export default "__VITE_ASSET__BgYKRg4K__"